import React, { useEffect, useState } from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody } from '../../components/ui/Table';
import { Input } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button/Button';

export const APIPricingDashboard: React.FC = () => {
  const [pricing, setPricing] = useState<any[]>([]);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    fetch('/api/billing/api-pricing?provider=&apiType=&unit=')
      .then(res => res.json())
      .then(setPricing);
  }, []);

  const filteredPricing = pricing.filter(p =>
    !filter ||
    p.provider?.includes(filter) ||
    p.apiType?.includes(filter) ||
    p.unit?.includes(filter)
  );

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">API Pricing Dashboard</h1>
      <Input
        placeholder="Filter by provider, type, or unit"
        value={filter}
        onChange={e => setFilter(e.target.value)}
        className="mb-4"
      />
      <div className="overflow-x-auto">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Provider</TableCell>
              <TableCell>API Type</TableCell>
              <TableCell>Unit</TableCell>
              <TableCell>Price Per Unit</TableCell>
              <TableCell>Effective From</TableCell>
              <TableCell>Effective To</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredPricing.map(p => (
              <TableRow key={p.id}>
                <TableCell>{p.provider}</TableCell>
                <TableCell>{p.apiType}</TableCell>
                <TableCell>{p.unit}</TableCell>
                <TableCell>{p.pricePerUnit}</TableCell>
                <TableCell>{new Date(p.effectiveFrom).toLocaleDateString()}</TableCell>
                <TableCell>{p.effectiveTo ? new Date(p.effectiveTo).toLocaleDateString() : 'Current'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}; 